"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityCreator = exports.EntityCreatorDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_lang_1 = require("../../hooks/use-lang");
var person_photo_1 = require("./person-photo");
var entity_link_1 = require("./entity-link");
var sprintf_js_1 = require("sprintf-js");
var tiny_relative_date_1 = __importDefault(require("tiny-relative-date"));
exports.EntityCreatorDefaultProps = {
  useUpdated: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    font-size: 1em;\n  "], ["\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    font-size: 1em;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-wrap: nowrap;\n  "], ["\n    flex-wrap: nowrap;\n  "])))
});
var PhotoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var NameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    white-space: nowrap;\n    font-size: 1em;\n  "], ["\n    white-space: nowrap;\n    font-size: 1em;\n  "])))
});
var ActionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    color: ", ";\n    margin-left: ", ";\n  "], ["\n    color: ", ";\n    margin-left: ", ";\n  "])), theme_1.theme.COLOR('text'), theme_1.theme.UNIT(1))
});
var TimeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    color: ", ";\n    margin-left: ", ";\n  "], ["\n    color: ", ";\n    margin-left: ", ";\n  "])), theme_1.theme.COLOR('text'), theme_1.theme.UNIT(1))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Photo: (0, styled_components_1.default)(person_photo_1.PersonPhoto)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), PhotoStyles),
  Name: (0, styled_components_1.default)(entity_link_1.EntityLink)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Action: styled_components_1.default.span(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ActionStyles),
  Time: styled_components_1.default.time(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), TimeStyles)
};
var EntityCreator = function (props) {
  var className = props.className,
    entity = props.entity,
    useUpdated = props.useUpdated;
  var createdBy = entity.createdBy,
    updatedBy = entity.updatedBy,
    updated = entity.updated,
    created = entity.created;
  var t = (0, use_lang_1.useLang)();
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity);
  if (!definition) {
    return null;
  }
  var person = useUpdated ? updatedBy : createdBy;
  var date = useUpdated ? updated : created;
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Photo, {
    size: 56,
    link: true,
    entity: person
  }), react_1.default.createElement(My.Name, {
    inverted: true,
    entity: person
  }), react_1.default.createElement(My.Action, null, (0, sprintf_js_1.sprintf)(t('added this %s'), definition.label)), created && react_1.default.createElement(My.Time, {
    datetime: created
  }, (0, tiny_relative_date_1.default)(date)));
};
exports.EntityCreator = EntityCreator;
exports.EntityCreator.defaultProps = exports.EntityCreatorDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;